import React from 'react';
import { GridActionsCellItem } from '@mui/x-data-grid';
import {
    DeleteIcon,
    DuplicateIcon,
} from '../../svg/UtilsIcons';

export const TemplateDeleteGridAction = ({ label, onClick }) => (
    <GridActionsCellItem
        icon={<DeleteIcon />}
        showInMenu
        label={label}
        onClick={onClick}
    />
);

export const TemplateDuplicateGridAction = ({ label, onClick }) => (
    <GridActionsCellItem
        icon={<DuplicateIcon />}
        showInMenu
        label={label}
        onClick={onClick}
    />
);

export const buildTemplateSelectedRowActions = ({
    canDeleteTemplate,
    deleteLabel,
    onDelete,
}) => [
    canDeleteTemplate
        ? {
            title: deleteLabel,
            color: 'rgb(236, 69, 78)',
            icon: <DeleteIcon color={'rgb(236, 69, 78)'} />,
            action: (ids) => {
                onDelete(ids);
            },
        }
        : null,
];
